import { PpaResponse } from '@afterpaytouch/portal-api'
import React, { FunctionComponent, useEffect } from 'react'
import styles from './style.module.css'

interface TruthInLendingIframeProps {
  documentData?: PpaResponse
  isTilDisclosure: boolean
}

export const TruthInLendingIframe: FunctionComponent<TruthInLendingIframeProps> = ({ documentData, isTilDisclosure }) => {
  useEffect(() => {
    const ppaIframe: HTMLIFrameElement | null = document.querySelector('#document-window')

    const scrollToTilDisclosure = (): void => {
      if (ppaIframe === null || ppaIframe.contentWindow === null) {
        return
      }
      ppaIframe.contentWindow.location.hash = 'truth-in-lending-disclosure'
    }

    if (isTilDisclosure) {
      ppaIframe?.addEventListener('load', scrollToTilDisclosure)
    }

    return () => {
      ppaIframe?.removeEventListener('load', scrollToTilDisclosure)
    }
  }, [isTilDisclosure])

  return <iframe id='document-window' className={styles.documentIframe} srcDoc={documentData?.renderedHtml}></iframe>
}
